<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col lg="4" xs="12" sm="8">
        <v-card :color="$vuetify.theme.dark ? '#2E2E2E' : 'grey lighten-3'">
          <v-overlay :value="!serverRunning" :absolute="true">
            <v-row justify="center">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-row>
          </v-overlay>
          <v-overlay :value="loaderOverlay" :absolute="true">
            <v-row justify="center">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-row>
          </v-overlay>
          <v-card-text>
            <v-row justfiy="center" align="center" no-gutters>
              <v-col cols="12" justfiy="center" :class="isMobile ? 'bigFontTime' : 'smallFontTime'" font-weight-regular>
                <div :class="'unselectable ' + CssFontTime" align="center" color="white" :style="{ color: +$vuetify.theme.dark ? 'white' : '' }">
                  {{ timeTXT }}
                </div>
              </v-col>
              <v-col cols="12" justfiy="center" font-weight-regular>
                <div :class="'unselectable ' + CssFontSize" align="center" :style="{ color: +$vuetify.theme.dark ? 'white' : '' }">
                  {{ dateTXT }}
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  ref="name"
                  prepend-icon="mdi-account"
                  v-model="editedItem.username"
                  :label="usernameText + ':'"
                  @keyup.enter="login()"
                  @keypress.native="filter"
                  ma-0
                  pa-0
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                  ref="address"
                  prepend-icon="mdi-lock"
                  v-model="editedItem.password"
                  :label="passwordText + ':'"
                  :type="showPass ? 'text' : 'password'"
                  :rules="[rules.required]"
                  @click:append="showPass = !showPass"
                  @keyup.enter="login()"
                  ma-0
                  pa-0
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mb-3"></v-divider>
            <v-row no-gutters align-content="center">
              <v-col cols="6" ms="6">
                <v-row no-gutters justify="center">
                  <v-btn color="primary" :class="$vuetify.theme.dark ? 'white' : 'textColor--text'" :min-width="buttonWidth" v-tap="(e) => login()"
                    >Login</v-btn
                  >
                </v-row>
              </v-col>
              <v-col cols="6" ms="6">
                <v-row no-gutters justify="center">
                  <v-btn
                    color="primary"
                    :class="$vuetify.theme.dark ? 'white' : 'textColor--text'"
                    :min-width="buttonWidth"
                    @click="dialogPin = !dialogPin"
                    v-if="dpBtnPin"
                    >Pin</v-btn
                  >
                  <v-btn
                    color="primary"
                    :class="$vuetify.theme.dark ? 'white' : 'textColor--text'"
                    :min-width="buttonWidth"
                    @click="dialogRFID = !dialogRFID"
                    v-if="dpBtnRFID"
                    >RFID</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <PinPad v-if="dialogPin" :PersistentDialog="false" @close="dialogPin = false" :dateText="dateTXT" :timeText="timeTXT" @success="showWelcomeDialog" />
    <Welcomedialog v-if="welcomeDialog" :name="$store.getters['user/user'].Name" :pic="userPicture"></Welcomedialog>
    <RFIDLogin v-if="dialogRFID" :dateText="dateTXT" :timeText="timeTXT" :saveMode="false" @success="showWelcomeDialog" @close="dialogRFID = false"></RFIDLogin>
    <ResetPassword
      v-if="dialogPasswordChange"
      hidden-sm-and-up
      :cssfontsize="CssFontTime"
      :newpasswordonlogin="false"
      :empid="userToEdit.SAPEmpID"
      @finished="showWelcomeDialog"
    ></ResetPassword>
  </v-container>
</template>

<script>
import ResetPassword from "../components/resetPassword";
import Welcomedialog from "../components/Login/WelcomeDialog";
import PinPad from "../components/Login/PinPad";

export default {
  name: "Login",
  route: "Login",
  components: { PinPad, Welcomedialog, ResetPassword, RFIDLogin: () => import("../components/Login/RFIDLogin") },
  data: function () {
    return {
      // Login.vue
      CssFontSize: ["body-2 "],
      CssFontTime: ["display-4"],
      CssFontStyleTime: ["color:" + this.$vuetify.theme.dark ? "white" : "white"],
      serverRunning: true,
      loaderOverlay: false,

      //=WelcomeMSGTimeoutInMS==========================
      messageDialogHideTimerInMs: 1500,
      syncTimeInMs: 5000,

      timer: "",
      logo: "",
      timeTXT: "00:00",
      dateTXT: "19.07.2019",
      showPass: false,
      apiRoot: window.location.origin + "/api/",
      empId: "",
      currentTime: "",
      tickCount: 0,
      firstRun: localStorage.getItem("firstRun"),

      dpBtnPin: true,
      dialogPinBack: true,
      dialogPin: false,
      btnEnter: true,

      dialogRFID: false,
      dpBtnRFID: false,

      dialogPasswordChange: false,

      welcomeDialog: false,
      userPicture: "",
      serverInSetupMode: false,

      rules: {
        required: (v) => !!v || "Erforderlich.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match"
      },
      editedItem: {
        username: "",
        password: ""
      },

      componentAlreadyDestroyed: false
    };
  },
  computed: {
    usernameText: function () {
      return this.$t("username");
    },
    passwordText: function () {
      return this.$t("password");
    },
    enterPinText: function () {
      return this.$t("enterPin");
    },
    isMobile: function () {
      return this.$store.getters["settings/isMobile"];
    },
    serverTime: function () {
      return this.$store.getters["server/serverTime"];
    },
    buttonWidth: function () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100px";
        default:
          return "150px";
      }
    }
  },

  async created() {
    await this.initialize();
    if (this.$store.getters["user/isLoggedIn"]) {
      //await this.getStatus()
      if (this.$store.getters["settings/terminalMode"] == "true" && this.$store.getters["user/user"].SAPEmpId != "0000") {
        this.$router.push({ name: "MainMenu", params: { refresh: "true" } });
      } else if (this.serverInSetupMode) {
        this.$router.push("Setup");
      } else if (this.$store.getters["user/user"].SAPEmpId === "0000") {
        //await this.getStatus()
        this.$router.push("UserAdministration");
        //this.$router.push("MainMenu");
      } else {
        this.$router.push("MainMenu");
      }
    }
  },
  destroyed() {
    this.componentAlreadyDestroyed = true;
    clearInterval(this.timer);
  },
  methods: {
    async initialize() {
      if (this.$store.getters["settings/deviceMode"] == "UserPassword") {
        this.dpBtnPin = false;
      } else if (this.$store.getters["settings/deviceMode"] == "Pin") {
        this.dialogPin = true;
        this.dialogPinBack = false;
      } else if (this.$store.getters["settings/deviceMode"] == "UserPasswordRFID") {
        this.dpBtnPin = false;
        this.dpBtnRFID = true;
      } else if (this.$store.getters["settings/deviceMode"] == "RFID") {
        this.dialogRFID = true;
        this.dpBtnPin = false;
        this.dpBtnRFID = true;
      }
      if (this.autoPinLogin == "true") {
        this.btnEnter = false;
      }

      await this.getTimeFromServer();

      Helper.unlockScrolling(false);
    },
    async getTimeFromServer() {
      await this.$store
        .dispatch("server/getServerTime")
        .then(() => {
          if (this.serverRunning == false) {
            this.$eventHub.$emit("showSuccess", this.$t("cobiServerUp"));
            this.serverRunning = true;
          }
          this.startTime();
        })
        .catch(async (err) => {
          if (!this.serverInSetupMode) {
            await this.checkIfServerInSetupMode();
          } else {
            this.$eventHub.$emit("showError", this.$t("cobiServerNotRunning"));
          }
          this.serverRunning = false;
          this.startTime();
        });
    },
    async checkIfServerInSetupMode() {
      await this.$store
        .dispatch("server/setup/checkIfServerInSetupMode")
        .then((res) => {
          if (res.data) this.serverInSetupMode = true;
        })
        .catch((err) => {});
    },
    async login() {
      var UserLogin = {
        user: this.editedItem.username,
        password: this.editedItem.password
      };
      this.loaderOverlay = true;
      await this.$store
        .dispatch("user/login", UserLogin)
        .then(async () => {
          let user = this.$store.getters["user/user"];
          if (user.needsToChangePassword) {
            // Change Password + Login
            let userToEdit = {
              editName: user.name,
              SAPEmpID: user.SAPEmpId,
              groupListselected: []
            };
            this.userToEdit = userToEdit;
            this.dialogPasswordChange = true;
          } else {
            this.showWelcomeDialog();
          }
          await this.getStatus();
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", this.$t(err.response.data.error), "bottom", "right");
          }
        });
      this.loaderOverlay = false;
    },
    filter(key) {
      if (key.charCode === 32) key.preventDefault();
      else return true;
    },
    synchronizeServerTime() {
      this.tickCount = 0;
      this.getTimeFromServer();
    },
    startTime() {
      this.tickCount++;
      var today = this.currentTime;
      if (this.tickCount == 5) {
        this.tickCount = 0;
        this.getTimeFromServer();
        return;
      }

      this.$store.dispatch("server/setTime", this.$moment(this.serverTime).add(1, "seconds"));

      this.timeTXT = this.$moment(this.serverTime).format("HH:mm");
      this.dateTXT = this.$moment(this.serverTime).locale(this.$vuetify.lang.current).format("dd, DD.MM.YYYY");

      if (!this.componentAlreadyDestroyed) {
        this.timer = setTimeout(this.startTime, this.syncTimeInMs);
      }
    },
    showWelcomeDialog() {
      this.userPicture = this.$store.getters["user/profilePicture"];
      this.welcomeDialog = true;
      app.loggedIn = true;
      setTimeout((data) => {
        if (this.$store.getters["settings/terminalMode"] == "true" && this.$store.getters["user/user"].SAPEmpId != "0000") {
          this.$eventHub.$emit("hideDrawer", true);
          this.$router.push({ name: "MainMenu", params: { refresh: "true" } });
        } else if (this.$store.getters["user/user"].SAPEmpId == "0000") {
          this.$router.push("UserAdministration");
        } else {
          this.$eventHub.$emit("hideDrawer", false);
          this.$router.push("MainMenu");
        }
      }, this.messageDialogHideTimerInMs);
    },
    async getStatus() {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("user/getStatus", {
          timeStamp: this.$moment(),
          executeImmediately: true
        })
        .then(async () => {
          this.loaderOverlay = false;
        })
        .catch((err) => {
          this.loaderOverlay = false;
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data, "bottom", "right");
          }
        });
    }
  }
};
//@ sourceURL=login.js
</script>
